import React, { useState } from 'react';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { trakrefBlue, inputGrey } from '../../color_utils';

const defaultStlyes = {
    '& label.Mui-focused': {
        color: trakrefBlue
    },
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: trakrefBlue
        }
    },
    '& .MuiFilledInput-root': {
        backgroundColor: inputGrey,
        '&.Mui-focused fieldset': {
            borderColor: trakrefBlue
        }
    },
    '& .MuiFilledInput-root:after': { borderBottomColor: trakrefBlue },
};

const PasswordField = ({
    label,
    onChange,
    onKeyDown,
    error,
    helperText,
    variant,
    required,
    disabled,
    value,
    fullWidth,
    sx,
}) => {
    const [values, setValues] = useState({
        password: '',
        showPassword: false,
    });

    const handleClickShowPassword = () => setValues({ ...values, showPassword: !values.showPassword });

    return (
        <TextField
            variant={variant || "filled"}
            type={values.showPassword ? 'text' : 'password'}
            label={ label}
            value={value}
            required={required}
            disabled={disabled}
            InputProps={{
                notched: !!value || value === 0,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={handleClickShowPassword}
                        >
                            {values.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            onChange={onChange}
            onKeyDown={onKeyDown}
            error={error}
            fullWidth={fullWidth}
            helperText={error ? helperText : ""}
            sx={{ ...defaultStlyes, ...sx }}
        />
    );
};

export default PasswordField;
